import React from 'react';
import Logo from '../svg/LogoV0';
import SplashContainer from '../../../splash/SplashContainer';

function Splash(props) {
  return <SplashContainer
    logo={<Logo color={'white'} width={200} height={41} style={{marginLeft: 8}} />}
    loadingWidth={240} loadingColor={'#4EDF84'} className={'splash-screen-container-v2'}
    {...props} />
}

export default Splash;
